import React from 'react';

const AffiliateProFx = React.lazy(() => import('./pages/Affiliate-profx'));

const routes = [ 
    //Root
    { path: '/', component: AffiliateProFx, isWithoutLayout: true }
];

export default routes;